import React, { Component } from 'react'
import Http from '../../config/axiosUtils';
import { Toast } from 'antd-mobile';
// import { AntOutline } from 'antd-mobile-icons'
import Swiper from 'swiper/dist/js/swiper.js'
import 'swiper/dist/css/swiper.css'
import './QrocdeSwiper.scss'
// import QRCode from 'qrcode.react';
// import tip from "../../assets/images/invite/tip.png"
class QrocdeSwiper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qrObj: [],
            len: 0,
            checkAll: false,
            longClick: 0,  // 长按标志
            timeOutEvent: 0,  // 计时器
            countTount: [],
            isLoading: false,
            type: 0,
            tips: '',
            imgData: []
        }
    }
    componentDidMount() {
        let type = window.sessionStorage.getItem("userType") === "custom" ? 1 : 2;
        this.setState({ type: type })
        this.goApply();
        // this.fetchTitle()
        // const that = this;
        new Swiper('.swiper-container', {
            loop: false,
            direction: 'horizontal',
            autoplayDisableOnInteraction: false,
            slidesPerView: "auto",
            centeredSlides: true,
            // spaceBetween: 20,
            nested: true, // 禁止父级滑块自动滑动功能
            observer: true, //修改swiper自己或子元素时，自动初始化swiper默认为false
            observeParents: true,//修改swiper的父元素时，自动初始化swiper
            effect: 'coverflow',
            // onTouchEnd: function (swiper) {
            //     var fileId = that.state.qrObj[swiper.activeIndex].fileId;
            //     if (that.state.countTount.indexOf(fileId) === -1) {
            //         html2canvas(document.getElementsByClassName("swiper-slide-active")[0], {
            //             allowTaint: false,
            //             x: 0, // x坐标
            //             y: 0, // y坐标
            //             scrollX: 0,
            //             scrollY: 0,
            //             width: 200,
            //             height: 400,
            //             foreignObjectRendering: true, // 是否在浏览器支持的情况下使用ForeignObject渲染
            //             useCORS: true, // 是否尝试使用CORS从服务器加载图像
            //             async: false, // 是否异步解析和呈现元素
            //             // 以下字段必填
            //             background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
            //             dpi: 1200, // 处理模糊问题
            //         }).then(function (canvas) {
            //             var arr1 = [];
            //             arr1[swiper.activeIndex] = canvas.toDataURL('image/png');
            //             that.setState({
            //                 imgData: arr1
            //             })
            //         })
            //         var arr = that.state.countTount;
            //         arr.push(fileId);
            //         that.setState({ longClick: 1, countTount: arr });  //  长按标志位
            //     }

            // }
        });
    }

    // fetchTitle = async () => {
    //     const path = '/tips/get';
    //     const res = await Http.get(path);
    //     if (res.code === 0) {
    //         var tips;
    //         console.log(this.state.type)
    //         if (this.state.type === 1) {
    //             tips = res.data.userTips
    //         } else {
    //             tips = res.data.teamTips
    //         }
    //         this.setState({
    //             tips: tips
    //         })
    //     }
    // }
    goApply = () => {
        // Toast.loading('加载中', 1, async () => {
        //     const path = '/source/manager/lists';
        //     let type = window.sessionStorage.getItem("userType") === "team" ? 2 : 1;
        //     let postData = { "useType": type }
        //     const res = await Http.post(path, postData);
        //     if (res.code === 0) {
        //         let imhLen = res.data && res.data.length;
        //         let width = 100 / imhLen + 50 + "%";
        //         this.setState({
        //             qrObj: res.data,
        //             len: width,
        //             type: type
        //         })
        //         // 在这里转化
        //         // setTimeout(() => {
        //         //     var that = this;
        //         //     // var firstId = that.state.qrObj[0].fileId;
        //         //     html2canvas(document.getElementsByClassName("swiper-slide")[0], {
        //         //         allowTaint: false,
        //         //         x: 0, // x坐标
        //         //         y: 0, // y坐标
        //         //         scrollX: 0,
        //         //         scrollY: 0,
        //         //         width: 200,
        //         //         height: 400,
        //         //         foreignObjectRendering: true, // 是否在浏览器支持的情况下使用ForeignObject渲染
        //         //         useCORS: true, // 是否尝试使用CORS从服务器加载图像
        //         //         async: false, // 是否异步解析和呈现元素
        //         //         // 以下字段必填
        //         //         background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
        //         //         dpi: 1200, // 处理模糊问题
        //         //     }).then(function (canvas) {
        //         //         var img1 = new Image();
        //         //         img1.src = canvas.toDataURL('image/png'); //背景图
        //         //         img1.onload = function () {
        //         //             var arr = [];
        //         //             arr[0] = canvas.toDataURL('image/png');
        //         //             that.setState({
        //         //                 imgData: arr
        //         //             })
        //         //             //图片路径 , x轴位置 , y轴位置 , 宽度 , 高度
        //         //         }

        //         //     })
        //         // }, 500)
        //         // 自己写
        //         // var newObj = this.state.qrObj[0];
        //         // var fId = this.state.qrObj[0].fileId;
        //         // if (newObj) {
        //         //     var c = document.getElementById(newObj.title);
        //         //     var ctx = c.getContext("2d");
        //         //     var img1 = new Image();
        //         //     img1.src = newObj.fileUrl; //背景图
        //         //     img1.onload = function () {
        //         //         ctx.drawImage(img1, 0, 17, 300, 150);
        //         //         //图片路径 , x轴位置 , y轴位置 , 宽度 , 高度
        //         //         var cv = document.getElementById(fId);
        //         //         var img2 = new Image();
        //         //         img2.src = cv.toDataURL("image/png") //背景图
        //         //         img2.onload = function () {
        //         //             ctx.drawImage(img2, 220, 125, 60, 20);
        //         //         }

        //         //     }
        //         // var oA = document.createElement("a");
        //         // oA.download = ''; // 设置下载的文件名，默认是'下载'
        //         // oA.href = c.toDataURL("image/png");
        //         // document.body.appendChild(oA);
        //         // oA.click();
        //         // oA.remove(); // 下载之后把创建的元素删除

        //         // var arr = [];
        //         // arr[0] = c.toDataURL("image/png")
        //         // this.setState({
        //         //     imgData: arr
        //         // })
        //         // ctx.fillText(this.state.tips, 10, 10, 300)
        //         // ctx.font = 'normal 15px 宋体';
        //         // ctx.color = "#000"
        //     }




        // })
        Toast.loading('加载中', 1, async () => {
            const path = '/source/manager/mergeLists';
            let type = window.sessionStorage.getItem("userType") === "custom"   ? 1: 2;
            let postData = { "useType": type }
            const res = await Http.post(path, postData);
            if (res.code === 0) {
                let imhLen = res.data && res.data.length;
                let width = 100 / imhLen + 50 + "%";
                this.setState({
                    qrObj: res.data,
                    len: width,
                    type: type
                })
            } else {
                Toast.fail(res.msg,2);
            }
        })
    }
    // start = (tag, tag2) => {
    //     let sp = document.getElementById(tag).className;
    //     let isActive = sp.split(" ").indexOf('swiper-slide-active')
    //     const that = this;
    //     // 此处为长按事件
    //     if (isActive !== -1) {
    //         if (this.state.countTount.indexOf(tag) === -1) {
    //             html2canvas(document.getElementById(tag), {
    //                 allowTaint: false,
    //                 useCORS: true,
    //                 x: 0, // x坐标
    //                 y: 0, // y坐标
    //                 foreignObjectRendering: true, // 是否在浏览器支持的情况下使用ForeignObject渲染
    //                 useCORS: true, // 是否尝试使用CORS从服务器加载图像
    //                 async: false, // 是否异步解析和呈现元素
    //                 // 以下字段必填
    //                 background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
    //                 dpi: 1200, // 处理模糊问题
    //             }).then(function (canvas) {

    //                 var arr = [];
    //                 arr[tag2] = canvas.toDataURL('image/png');
    //                 that.setState({
    //                     imgData: arr
    //                 })
    //             });
    //         }
    //         var arr = this.state.countTount;
    //         arr.push(tag);
    //         this.setState({ longClick: 1, countTount: arr });  //  长按标志位
    //     }
    // }

    render() {
        return (
            <div>
                <div className="swiper-container">
                    <div className="swiper-wrapper">
                        {this.state.qrObj.map((obj, index) => <div className="swiper-slide" key={obj.fileId} >
                            {/* <canvas id={obj.title} className="hb ne">    </canvas> */}
                            {/* <div className="tip"> <img src={tip} width="16" alt="" /> {this.state.tips}</div> */}
                            {/* <img alt="" id={obj.id} className="hb" src={this.state.imgData[index]} /> */}
                            {/* {this.getBase64Image(obj.fileUrl)} */}
                            <img src={obj.fileBase64} alt="" className="fileImg" />
                            {/* <QRCode value={this.props.qrUrl} size={60} className="qr" id={obj.fileId} /> */}
                        </div>

                        )}
                    </div>
                </div>
                <div>
                    {this.state.len !== 0 && <p className="erro" >长按海报保存</p>
                    }
                </div>

            </div >
        )
    }
}
export default QrocdeSwiper;

